(function(window) {
    if ($('.callout-tile__telephone-link').length <= 0) {
        return;
    }

    let telephoneLinks = document.querySelectorAll(
        '.callout-tile__telephone-link'
    );
    telephoneLinks.forEach(function(item) {
        if (item.href.length < 5) {
            item.remove();
        }
    });
})(window);
